const fr = {
  // ── Header nav ──────────────────────────────────────────────────────────────
  nav: {
    home: 'ACCUEIL',
    collections: 'COLLECTIONS',
    allCollections: 'Toutes les collections',
    bathroom: 'SALLE DE BAIN',
    sanitaryAppliances: 'Appareils sanitaires',
    bathroomFurniture: 'Meubles de salle de bain',
    faucets: 'Robinetterie',
    showerSystems: 'Systèmes de douche',
    complementaryProducts: 'Produits complémentaires',
    bathroomAccessories: 'Accessoires de bain',
    kitchens: 'CUISINES',
    seeAll: 'Voir tout',
    joinery: 'MENUISERIE',
    pvcDoors: 'Portes & fenêtres PVC',
    aluDoors: 'Portes & fenêtres ALU',
    rollerShutters: 'Volets roulants',
    guillotineSystems: 'Systèmes guillotine',
    garageDoors: 'Portes de garage',
    entryDoors: "Portes d'entrée",
    mosquitoNets: 'Moustiquaires',
    glassSolutions: 'Solutions vitrées',
    pivotDoors: 'Portes pivot Aderka',
    exterior: 'EXTÉRIEUR',
    pergolas: 'Pergolas',
    sunProtection: 'Protection solaire',
    catalogues: 'CATALOGUES',
    realizations: 'RÉALISATIONS',
    contact: 'CONTACT',
  },

  // ── Footer ───────────────────────────────────────────────────────────────────
  footer: {
    tagline: "L'art de vivre raffiné",
    showroom: 'SHOWROOM',
    byAppointment: 'Sur rendez-vous uniquement',
    contact: 'CONTACT',
    followUs: 'SUIVEZ-NOUS',
    rights: '© 2025 SRA Global Trading. Tous droits réservés.',
  },

  // ── HomePage ─────────────────────────────────────────────────────────────────
  home: {
    expertises: 'NOS EXPERTISES',
    expertisesSubtitle: "L'excellence dans chaque détail",
    explore: 'DÉCOUVRIR',
    cta: {
      title: 'DONNONS VIE À VOTRE PROJET',
      text: 'Notre équipe d\'experts vous accompagne dans la création de votre projet sur mesure',
      button: 'PRENDRE RENDEZ-VOUS',
    },
    viewAllCollections: 'Voir toutes nos collections',
  },

  // ── Collections page ─────────────────────────────────────────────────────────
  collections: {
    title: 'Collections de Carrelage — 244 Collections',
    ourCollections: 'NOS COLLECTIONS',
    searchPlaceholder: 'Rechercher...',
    category: 'Catégorie',
    allCategories: 'Toutes les catégories',
    collection: 'Collection',
    allCollections: 'Toutes les collections',
    size: 'Taille',
    allSizes: 'Toutes les tailles',
    material: 'Matériau',
    allMaterials: 'Tous les matériaux',
    filters: 'Filtres',
    clear: 'Effacer',
    close: 'Fermer',
    noResults: 'Aucun produit ne correspond à vos critères.',
    clearFilters: 'Effacer les filtres',
    productsFound_one: '{{count}} produit trouvé',
    productsFound_other: '{{count}} produits trouvés',
  },

  // ── Collection detail page ───────────────────────────────────────────────────
  collectionDetail: {
    back: 'Retour aux collections',
    home: 'Accueil',
    viewRender: 'Voir le rendu',
    documents: 'Documents',
    file: 'Fichier',
    viewAll: 'Voir toutes nos collections',
    similarCollections: 'Collections similaires',
    surface: 'Surface',
    size: 'Taille',
    color: 'Couleur',
    finish: 'Finition',
    availableProducts: 'Produits disponibles',
    applications: 'Applications',
    about: 'À propos',
    aboutText: 'La collection {{name}} allie esthétique contemporaine et performance technique. Disponible en plusieurs formats et coloris, elle s\'adapte à tous vos espaces intérieurs et extérieurs.',
    specs: 'Spécifications',
    otherCollections: 'AUTRES COLLECTIONS',
    notFound: 'Collection non trouvée',
    enlargedView: 'Vue agrandie',
    breadcrumbCollections: 'Collections',
    collectionLabel: 'Collection',
    viewsCount: '{{count}} vues',
    facesCount: '{{count}} faces',
    viewLabel: 'Vue',
  },

  // ── Generic ──────────────────────────────────────────────────────────────────
  common: {
    back: 'Retour',
    home: 'Accueil',
    search: 'Rechercher...',
    searchProduct: 'Rechercher un produit...',
    viewCatalogue: 'Voir le catalogue',
    viewModel: 'Voir le modèle',
    viewLarge: 'Voir en grand',
    download: 'Télécharger',
    contact: 'contactez-nous',
  },

  // ── Category names (used in data) ────────────────────────────────────────────
  categories: {
    'Carrelage': 'Carrelage',
    'Sanitaire': 'Sanitaire',
    'Cuisine': 'Cuisine',
    'Menuiserie': 'Menuiserie',
    'Extérieur': 'Extérieur',
    'Salle de bain': 'Salle de bain',
    'Intérieur': 'Intérieur',
    'Extérieur pierre': 'Extérieur pierre',
  },

  // ── Room categories (roomCategoriesData) ─────────────────────────────────────
  roomCategories: {
    sectionTitle: 'ESPACES PAR DESTINATION',
    sectionSubtitle: 'Des solutions sur mesure pour chaque environnement',
    'Cuisine': 'Cuisine',
    'Salle de Bain': 'Salle de Bain',
    'Intérieur': 'Intérieur',
    'Extérieur': 'Extérieur',
    'Jardin': 'Jardin',
    'Terrasse': 'Terrasse',
  },

  // ── Product categories (productCategoriesData) ────────────────────────────────
  productCategories: {
    'Cuisines sur Mesure': 'Cuisines sur Mesure',
    'Appareils Sanitaires': 'Appareils Sanitaires',
    'Meubles de Salle de Bain': 'Meubles de Salle de Bain',
    'Robinetterie de Luxe': 'Robinetterie de Luxe',
    'Systèmes de Douche': 'Systèmes de Douche',
    'Produits Complémentaires': 'Produits Complémentaires',
    'Accessoires de Bain': 'Accessoires de Bain',
    'Menuiserie': 'Menuiserie',
    'Extérieur & Pergolas': 'Extérieur & Pergolas',
  },

  // ── Product descriptions (productCategoriesData) ──────────────────────────────
  productDescriptions: {
    'Cuisines sur Mesure': 'Atölye Mutfak & Soprano — 31 modèles, tous styles et finitions',
    'Appareils Sanitaires': 'Baignoires, vasques et WC aux lignes architecturales épurées',
    'Meubles de Salle de Bain': 'Collections Kobos — élégance et fonctionnalité sur mesure',
    'Robinetterie de Luxe': 'Finitions sophistiquées — or brossé, noir mat, chrome poli',
    'Systèmes de Douche': 'Solutions de douche premium — colonnes, parois et receveurs d\'exception',
    'Produits Complémentaires': 'Accessoires et compléments pour sublimer votre salle de bain',
    'Accessoires de Bain': 'Miroirs, porte-serviettes et accessoires design pour votre espace',
    'Menuiserie': 'Portes, fenêtres PVC & ALU, volets roulants et systèmes guillotine',
    'Extérieur & Pergolas': 'Pergolas motorisées, stores ZIP et vitrages guillotine pour vos terrasses',
  },

  // ── Colors (product colors in collections) ────────────────────────────────────
  colors: {
    'Blanc': 'Blanc', 'Ivoire': 'Ivoire', 'Crème': 'Crème', 'Beige': 'Beige',
    'Sable': 'Sable', 'Latte': 'Latte', 'Caramel': 'Caramel', 'Bone': 'Bone',
    'Gris': 'Gris', 'Greige': 'Greige', 'Gris Clair': 'Gris Clair',
    'Gris Foncé': 'Gris Foncé', 'Argent': 'Argent', 'Perle': 'Perle',
    'Fumée': 'Fumée', 'Taupe': 'Taupe',
    'Noir': 'Noir', 'Anthracite': 'Anthracite',
    'Brun': 'Brun', 'Moka': 'Moka', 'Café': 'Café', 'Cotto': 'Cotto',
    'Or': 'Or', 'Doré': 'Doré', 'Cuivre': 'Cuivre',
    'Bleu': 'Bleu', 'Marine': 'Marine', 'Vert': 'Vert',
    'Rouge': 'Rouge', 'Bordeaux': 'Bordeaux', 'Rose': 'Rose',
    'Naturel': 'Naturel', 'Mix': 'Mix', 'Décofon': 'Décofon',
    'Pierre': 'Pierre', 'Sauge': 'Sauge', 'Kaki': 'Kaki',
    'Chêne': 'Chêne', 'Noyer': 'Noyer', 'Venge': 'Venge',
  },

  // ── Surfaces ──────────────────────────────────────────────────────────────────
  surfaces: {
    'Mat': 'Mat',
    'Brillant': 'Brillant',
    'Full Lappato': 'Full Lappato',
    'Lappato': 'Lappato',
    'Poli': 'Poli',
    'Satiné': 'Satiné',
  },

  // ── Collections Showcase (HomePage) ───────────────────────────────────────────
  collectionsShowcase: {
    title: 'Collections Signature',
    subtitle: 'Faites glisser pour explorer nos créations les plus emblématiques',
    viewAll: 'Voir toutes nos collections',
  },

  // ── Catalogue page ───────────────────────────────────────────────────────────
  catalogue: {
    title: 'NOS CATALOGUES',
    subtitle: "Téléchargez nos catalogues pour découvrir l'ensemble de nos collections",
  },

  // ── Shop pages (category list + detail templates) ──────────────────────────────
  shop: {
    home: 'Accueil',
    all: 'Tous',
    allNeutral: 'Tout',
    allFem: 'Toutes',
    filters: 'FILTRES',
    clearAll: 'Effacer tout',
    close: 'Fermer',
    reset: 'Réinitialiser',
    resetFilters: 'Réinitialiser les filtres',
    productNotFound: 'Produit non trouvé',
    modelNotFound: 'Modèle non trouvé',
    noProductsFound: 'Aucun produit trouvé.',
    noModelsFound: 'Aucun modèle trouvé.',
    noCollectionsFound: 'Aucune collection trouvée.',
    productsFoundCount_one: '{{count}} produit trouvé',
    productsFoundCount_other: '{{count}} produits trouvés',
    modelsFoundCount_one: '{{count}} modèle trouvé',
    modelsFoundCount_other: '{{count}} modèles trouvés',
    brand: 'Marque',
    requestQuote: 'Demander un devis',
    productSheet: 'Fiche produit (.rar)',
    similarProducts: 'PRODUITS SIMILAIRES',
    discover: 'Découvrir',
    category: 'CATÉGORIE',
    color: 'COULEUR',
    seriesCollection: 'SÉRIE / COLLECTION',
    productType: 'TYPE DE PRODUIT',
    colorFinish: 'COULEUR / FINITION',
  },

  // ── Sanitaire pages ──────────────────────────────────────────────────────────
  sanitaire: {
    backLink: 'Retour à la salle de bain',
    description: "Produit sanitaire de qualité supérieure, alliant design contemporain et durabilité. Pour plus d'informations ou pour obtenir un devis, contactez notre showroom.",
  },

  // ── Tamamlayici (complementary products) pages ──────────────────────────────
  tamamlayici: {
    pageTitle: 'ACCESSOIRES SALLE DE BAIN',
    pageTitleCase: 'Accessoires salle de bain',
    backLink: 'Retour aux accessoires',
    description: "Accessoire de salle de bain de qualité supérieure. Pour plus d'informations ou pour obtenir un devis, contactez notre showroom.",
  },

  // ── Armaturler (faucets) pages ───────────────────────────────────────────────
  armaturler: {
    pageTitle: 'ROBINETTERIE & DOUCHE',
    pageTitleCase: 'Robinetterie & Douche',
    backLink: 'Retour à la robinetterie',
    description: "Robinet de qualité supérieure, conçu pour allier esthétique et performance. Pour plus d'informations ou pour obtenir un devis, contactez notre showroom.",
  },

  // ── Dus (shower systems) pages ───────────────────────────────────────────────
  dus: {
    pageTitle: 'SYSTÈMES DE DOUCHE',
    pageTitleCase: 'Systèmes de douche',
    backLink: 'Retour aux systèmes de douche',
    description: "Système de douche de qualité supérieure, conçu pour allier esthétique et performance. Pour plus d'informations ou pour obtenir un devis, contactez notre showroom.",
  },

  // ── Aksesuar (bath accessories) pages ────────────────────────────────────────
  aksesuar: {
    pageTitle: 'ACCESSOIRES SALLE DE BAIN',
    pageTitleCase: 'Accessoires Salle de Bain',
    backLink: 'Retour aux accessoires',
    description: "Accessoire de salle de bain de qualité supérieure, alliant design et fonctionnalité. Pour plus d'informations ou pour obtenir un devis, contactez notre showroom.",
  },

  // ── Cuisine (custom kitchens) pages ──────────────────────────────────────────
  cuisine: {
    pageTitle: 'CUISINES SUR MESURE',
    pageTitleCase: 'Cuisines',
    search: 'RECHERCHE',
    searchPlaceholder: 'Nom du modèle...',
    brand: 'MARQUE',
    style: 'STYLE',
    finish: 'FINITION',
    backLink: 'Retour aux cuisines',
    sameStyle: 'DANS LE MÊME STYLE',
  },

  // ── Kobos (bathroom furniture) pages ─────────────────────────────────────────
  kobos: {
    pageTitle: 'MEUBLES DE SALLE DE BAIN',
    pageTitleCase: 'Meubles de Salle de Bain',
    availableCount_one: '{{count}} collection disponible',
    availableCount_other: '{{count}} collections disponibles',
    searchPlaceholder: 'Nom de la collection...',
    notFound: 'Collection introuvable.',
    backLinkArrow: 'Retour aux meubles',
    photosCount: '{{count}} photos',
    categoryLabel: 'Meuble de salle de bain · Kobos',
    availableDimensions: 'DIMENSIONS DISPONIBLES',
    finishes: 'FINITIONS',
    material: 'MATÉRIAU',
    otherCollections: 'AUTRES COLLECTIONS',
  },

  // ── Soprano (custom kitchens) pages ──────────────────────────────────────────
  soprano: {
    pageTitle: 'CUISINES SUR MESURE',
    pageTitleCase: 'Cuisines sur Mesure',
    availableCount_one: '{{count}} modèle disponible',
    availableCount_other: '{{count}} modèles disponibles',
    notFound: 'Modèle introuvable.',
    backLinkArrow: 'Retour aux cuisines',
    photosCount: '{{count}} photos',
    categoryLabel: 'Cuisine sur mesure · Soprano',
    availableFinishes: 'FINITIONS DISPONIBLES',
    manufacturing: 'FABRICATION',
    manufacturingDetail: 'Sur mesure · Laque mate, bois, MDF premium',
    otherModels: 'AUTRES MODÈLES',
  },

  // ── Exterieur (pergolas) pages ───────────────────────────────────────────────
  exterieur: {
    subtitle: 'PERGOLAS & PROTECTION SOLAIRE',
    viewAll: 'Tout voir',
    productCount_one: '{{count}} produit',
    productCount_other: '{{count}} produits',
    specs: 'CARACTÉRISTIQUES',
    otherProducts: 'AUTRES PRODUITS',
  },

  // ── Menuiserie (joinery) pages ───────────────────────────────────────────────
  menuiserie: {
    pageTitle: 'MENUISERIE',
    pageTitleCase: 'Menuiserie',
    subtitle: 'Fenêtres, portes et solutions sur mesure',
    productCount_one: '{{count}} produit',
    productCount_other: '{{count}} produits',
    clearAll: 'Tout effacer',
    viewMore: 'Voir plus',
    viewLess: 'Voir moins',
    specs: 'CARACTÉRISTIQUES',
    otherProducts: 'AUTRES PRODUITS',
    categoryNotFound: 'Catégorie introuvable.',
    backLink: 'Retour à la menuiserie',
    searchModelPlaceholder: 'Rechercher un modèle...',
  },

  // ── Aderka (pivot doors) pages ───────────────────────────────────────────────
  aderka: {
    pageTitle: 'PORTES PIVOT ALUMINIUM',
    pageSubtitle: 'Aderka Door Systems — 4 séries, 19 modèles',
    modelsCount: '{{count}} modèles',
    discoverSeries: 'Découvrir la série',
    seriesDescriptions: {
      exclusive: 'Lignes architecturales épurées',
      stoneline: 'Finition effet pierre naturelle',
      elegance: 'Élégance contemporaine — 10 modèles',
      woodline: 'Texture bois sur châssis aluminium',
    },
    pageTitleFallback: 'PORTES PIVOT',
    modelCount_one: '{{count}} modèle',
    modelCount_other: '{{count}} modèles',
    doorSystemsSuffix: 'Aderka Door Systems',
    allSeries: 'Toutes les séries',
    viewModel: 'Voir le modèle',
    breadcrumbHome: 'Accueil',
    breadcrumbPivotDoors: 'Portes Pivot',
    notFound: 'Modèle introuvable.',
    backToSeries: 'Retour aux séries',
    material: 'Matériau',
    finish: 'Finition',
    style: 'Style',
    dimensions: 'Dimensions',
    series: 'Série',
    usage: 'Usage',
    materialAluminium: 'Aluminium',
    dimensionsCustom: 'Sur-mesure',
    usageExterior: 'Extérieur',
    requestQuote: 'Demander un devis',
    seriesLinkPrefix: 'Série',
    sameRangeModels: 'MODÈLES DE LA MÊME GAMME',
    seriesFinish: {
      exclusive: 'Laquée mat',
      stoneline: 'Effet pierre naturelle',
      elegance: 'Moderne élégante',
      woodline: 'Effet bois authentique',
    },
    seriesStyle: {
      exclusive: 'Architecturale',
      stoneline: 'Minérale',
      elegance: 'Contemporaine',
      woodline: 'Naturelle',
    },
    seriesLongDescriptions: {
      exclusive: "La série Exclusive incarne l'alliance entre rigueur architecturale et sophistication absolue. Ses lignes épurées et ses proportions maîtrisées en font un élément signature pour les entrées haut de gamme. Chaque modèle est conçu pour s'imposer comme une pièce maîtresse, alliant résistance et esthétique intemporelle.",
      stoneline: "Stoneline réinvente la porte pivot en intégrant une finition effet pierre naturelle d'une authenticité remarquable. Ce traitement de surface unique confère à chaque porte un caractère minéral fort, transformant l'entrée en une déclaration artistique tout en conservant toutes les performances techniques de l'aluminium.",
      elegance: "La série Elegance décline la porte pivot en dix expressions distinctes, toutes animées par un même fil conducteur : l'élégance contemporaine sans ostentation. Des formes travaillées, des jeux de matières subtils et une finition soignée font de chaque modèle une invitation à l'entrée qui marque les esprits durablement.",
      woodline: "Woodline combine la chaleur du bois avec les performances inégalées de l'aluminium. Sa texture bois authentique est obtenue par un procédé de thermolaquage haute définition qui reproduit fidèlement les veines et nuances du bois naturel. Idéale pour les intérieurs modernes qui recherchent la chaleur sans les contraintes d'entretien.",
    },
    features: {
      aluminium: { label: 'Aluminium haute résistance', sub: 'Profilés aluminium renforcés' },
      pivotSystem: { label: 'Système pivot haute performance', sub: 'Rotation 360° — pivot dissimulé' },
      insulation: { label: 'Isolation thermique & acoustique', sub: 'Rupture de pont thermique' },
      customFinish: { label: 'Finitions sur-mesure', sub: 'Coloris RAL au choix' },
    },
  },

  // ── Product detail page (tile products) ──────────────────────────────────────
  productDetail: {
    notFound: 'Produit non trouvé',
    backToCollections: 'Retour aux collections',
    faceAlt: 'Face {{index}}',
    viewAlt: 'Vue {{index}}',
    optionsTitle: 'Options du produit',
    sizeLabel: 'Taille',
    colorLabel: 'Coloris',
    finishLabel: 'Finition',
    technicalSpecsTitle: 'Caractéristiques techniques',
    specsPendingText: 'Les caractéristiques techniques détaillées seront disponibles prochainement.',
    specsPendingContact: 'Pour toute information, contactez-nous.',
    packagingTitle: 'Emballage',
    documentsTitle: 'Documents',
    requestQuote: 'Demander un devis',
  },

  // ── Products page ────────────────────────────────────────────────────────────
  products: {
    title: 'NOS PRODUITS',
    subtitle: 'Des produits de qualité premium sourcés auprès de partenaires internationaux',
    all: 'Tous',
    explore: 'DÉCOUVRIR',
    ctaText: 'Vous cherchez un produit spécifique ? Contactez notre équipe directement.',
    getInTouch: 'NOUS CONTACTER',
  },

  // ── About page ───────────────────────────────────────────────────────────────
  about: {
    title: 'À PROPOS DE NOUS',
    whoWeAre: 'Qui Sommes-Nous',
    paragraph1: "SRA Global Trading est une société basée à Dubaï, spécialisée dans l'approvisionnement, la fourniture et la distribution de produits de qualité premium dans les secteurs de la construction, de la décoration intérieure et du négoce général.",
    paragraph2: "Situés au cœur du quartier des affaires de Dubaï, à la Latifa Tower sur Sheikh Zayed Road, nous sommes idéalement positionnés pour servir les marchés du Moyen-Orient, de l'Afrique et au-delà. Notre emplacement stratégique nous donne accès à un vaste réseau de fournisseurs internationaux et de partenaires logistiques.",
    paragraph3: "Nous sommes fiers de livrer l'excellence à chaque étape — de la sélection des produits et du contrôle qualité à la livraison dans les délais et au support après-vente. Notre équipe expérimentée apporte des décennies d'expertise combinée en négoce et approvisionnement.",
    ourValues: 'NOS VALEURS',
    values: {
      excellence: { name: 'Excellence', desc: 'Nous sourçons uniquement des produits de la plus haute qualité auprès de fournisseurs certifiés dans le monde entier.' },
      integrity: { name: 'Intégrité', desc: 'La transparence et l\'honnêteté sont le fondement de chaque partenariat que nous construisons.' },
      partnership: { name: 'Partenariat', desc: 'Nous investissons dans des relations durables avec nos clients et fournisseurs.' },
      innovation: { name: 'Innovation', desc: 'Nous faisons constamment évoluer notre gamme de produits pour répondre aux exigences des marchés modernes.' },
    },
    readyToWork: 'Prêt à travailler avec nous ?',
    contactUs: 'CONTACTEZ-NOUS',
  },

  // ── Contact page ─────────────────────────────────────────────────────────────
  contact: {
    title: 'CONTACTEZ-NOUS',
    subtitle: 'Notre équipe est disponible pour répondre à toutes vos demandes',
    ourDetails: 'Nos Coordonnées',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'E-mail',
    businessHours: "Horaires d'ouverture",
    closed: 'Fermé',
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    sendMessage: 'Envoyez-nous un Message',
    successMessage: 'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.',
    error: "Une erreur s'est produite. Veuillez réessayer ou nous contacter directement.",
    fullName: 'Nom Complet',
    subject: 'Sujet',
    message: 'Message',
    sending: 'Envoi en cours...',
    sendMessageBtn: 'Envoyer le Message',
  },

  // ── Realisations page ──────────────────────────────────────────────────────────
  realisations: {
    pageTitle: 'Nos Réalisations',
    pageSubtitle: "Des projets d'exception, au cœur de l'Afrique",
    historyTitle: 'Un lieu riche en histoire',
    zonesTitle: 'Quatre zones, un pôle urbain majeur',
    imagesTitle: 'Le projet en images',
    progressTitle: 'Le chantier avance',
    progressSubtitle: "Faites glisser pour suivre l'évolution des travaux",
    developedBy: 'Développé par',
    downloadBrochure: 'Télécharger la brochure',
  },
};

export default fr;
